import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector, connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import {
  getProductDetail,
  outOfStock,
  getProductReview,
} from "../../store/product/product.action";
import { getDefaultCurrency } from "../../store/currency/currency.action";
import Pagination from "../../extra/Pagination";

const ProductDetail = (props) => {
  const { productDetail, review } = useSelector((state) => state.product);
  const { defaultCurrency } = useSelector((state) => state.currency);
  const { state } = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const swiperRef = useRef(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [size, setSize] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedSleeve, setSelectedSleeve] = useState(null);

  useEffect(() => {
    dispatch(getProductDetail(state));
    dispatch(getDefaultCurrency());
  }, [state, dispatch]);

  useEffect(() => {
    dispatch(getProductReview(state, currentPage, size));
  }, [state, currentPage, size, dispatch]);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const val = parseInt(event, 10);
    setRowsPerPage(val);
    setSize(val);
    setCurrentPage(1);
  };

  return (
    <div style={{ background: "#f4f5f7", minHeight: "100vh", padding: "2rem", backgroundColor: "#F8F7FA" }}>

      <div className="d-flex justify-content-between align-items-center" style={{ marginTop: "-25px" }}>
        <div className=" headname" style={{ marginLeft: "0px" }} >Product Detail </div>
        <div>
          <button
            onClick={() => navigate(-1)}
            className="btn exitbtn  rounded-pill px-4 mb-4"
            style={{ border: "1px solid #b93160", marginLeft: "10px" }}
          >
            ← Back
          </button>
        </div>
      </div>
      <div className="bg-white  shadow-lg  p-4 " style={{ borderRadius: "5px" }}  >


        {/* Product Section - Image Left, Info Right */}
        <div className="row g-4">
          {/* LEFT BOX: Images */}
          <div className="col-lg-6">
            <div className="bg-white shadow-none rounded-4 p-3 h-100">
              <div className="row g-3">
                {/* LEFT: Swiper Thumbnail (Vertical) */}
                <div className="col-2">
                  <Swiper
                    direction="vertical"
                    spaceBetween={10}
                    slidesPerView={4}
                    navigation
                    modules={[Navigation]}
                    style={{ height: "350px", width: "80px" }}
                  >
                    {productDetail[0]?.images.map((img, index) => (
                      <SwiperSlide key={index}>
                        <img
                          src={img}
                          alt={`thumb-${index}`}
                          onClick={() => swiperRef.current?.slideTo(index)}
                          style={{
                            width: "100%",
                            height: "80px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            border: "2px solid #ccc",
                            cursor: "pointer",
                            transition: "border 0.1s ease-in"
                          }}
                          onMouseOver={(e) => (e.currentTarget.style.border = "2px solid #b93160")}
                          onMouseOut={(e) => (e.currentTarget.style.border = "2px solid #ccc")}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>

                {/* RIGHT: Main Product Image */}
                <div className="col-10">
                  <Swiper
                    modules={[Navigation]}
                    spaceBetween={10}
                    slidesPerView={1}
                    onSwiper={(swiper) => (swiperRef.current = swiper)}
                    style={{ height: "600px", borderRadius: "12px", overflow: "hidden" }}
                  >
                    {productDetail[0]?.images.map((img, index) => (
                      <SwiperSlide key={index}>
                        <img
                          src={img}
                          alt={`image-${index}`}
                          className="w-100 h-100"
                          style={{
                            objectFit: "cover",
                            borderRadius: "12px"
                          }}
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </div>
            </div>

          </div>

          {/* RIGHT BOX: Product Info */}

          <div className="col-lg-6">
            <div className="bg-white shadow-md rounded-4 p-4 h-100">
              <h3 className="mb-2 text-dark">{productDetail[0]?.productName}</h3>
              <div className="d-flex gap-4 mb-3 ">
                <div className="mt-1">
                  <p className="text-muted mb-1">Product Code: <strong>{productDetail[0]?.productCode}</strong></p>
                  <p className="text-muted mb-1">Category: {productDetail[0]?.category?.name}</p>


                  <div class="d-flex flex-wrap gap-2 align-items-center mb-2">
                    <div class="text-muted fs-16">
                      <Rating
                        initialValue={
                          productDetail[0]?.rating[0]?.avgRating
                        }
                        readonly={true}
                        allowFraction
                      />
                    </div>
                    <div class="text-white fw-normal">
                      {"(" +
                        productDetail[0]?.review +
                        " Customer Review )"}
                    </div>
                  </div>
                </div>
                <div>
                  <p className="text-muted mb-1">Seller: {productDetail[0]?.seller?.firstName}</p>
                  <span
                    className={`badge ${productDetail[0]?.isOutOfStock ? "bg-danger" : "bg-success"} mb-3`}
                    style={{ padding: "0.4rem 1rem", fontSize: "0.85rem" }}
                  >
                    {productDetail[0]?.isOutOfStock ? "Out of Stock" : "In Stock"}
                  </span>
                </div>
              </div>

              <div className="row g-3">
                {[
                  {
                    label: "Price",
                    value: productDetail[0]?.price,
                    icon: "bi-cash",
                    iconColor: "#28a745",
                    bg: "#DCF6E8"
                  },
                  {
                    label: "Shipping",
                    value: productDetail[0]?.shippingCharges,
                    icon: "bi-truck",
                    iconColor: "#0d6efd",
                    bg: "#E9F0FB"
                  },
                  {
                    label: "Sold",
                    value: productDetail[0]?.sold,
                    icon: "bi-graph-up",
                    iconColor: "#ffc107",
                    bg: "#FFF7E6"
                  },
                  {
                    label: "Tag",
                    value: productDetail[0]?.seller?.businessTag,
                    icon: "bi-tag",
                    iconColor: "#dc3545",
                    bg: "#FDECEC"
                  }
                ].map((item, idx) => (
                  <div key={idx} className="col-md-5">
                    <div
                      className="d-flex align-items-center gap-3 rounded-4 p-3 shadow-sm"
                      style={{ backgroundColor: item.bg, minHeight: "85px" }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center rounded-circle"
                        style={{
                          width: "40px",
                          height: "40px",
                          backgroundColor: "#fff",
                          border: `2px solid ${item.iconColor}`
                        }}
                      >
                        <i className={`bi ${item.icon}`} style={{ color: item.iconColor, fontSize: "1.2rem" }}></i>
                      </div>

                      <div>
                        <div className="fw-bold text-dark" style={{ fontSize: "14px" }}>{item.label}</div>
                        <div style={{ fontSize: "15px" }}>
                          <span className="text-dark">
                            {item.label === "Tag" ? item.value : `${defaultCurrency?.symbol}${item.value}`}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>


              <div className="mt-4">
                <h5>Description</h5>
                <p className="text-secondary small">{productDetail[0]?.description}</p>
              </div>

              <div className="row">
                {productDetail[0]?.attributes?.map((attr) => {
                  const titleMap = {
                    colors: "Color",
                    size: "Select Size",
                    sleeves: "Select Sleeve",
                  };

                  return (
                    <div className="col-6 mb-4" key={attr._id}>
                      <h6 className="mb-2">{titleMap[attr.name] || attr.name}</h6>
                      <div className="d-flex flex-wrap gap-2">
                        {attr.value.map((val, i) => {
                          const isSelected =
                            attr.name === "colors"
                              ? selectedColor === val
                              : attr.name === "sleeves"
                                ? selectedSleeve === val
                                : selectedSize === val;

                          const handleClick = () => {
                            if (attr.name === "colors") setSelectedColor(val);
                            else if (attr.name === "sleeves") setSelectedSleeve(val);
                            else setSelectedSize(val);
                          };
                          // console.log(attr.name)
                          const style =
                            attr.name === "colors" || attr.name === "Colors"
                              ? {
                                width: "20px",
                                height: "20px",
                                borderRadius: "50%",
                                border: isSelected ? "1px solid #000" : "1px solid #ccc",
                                backgroundColor: val,
                                cursor: "pointer",
                                outline: "none",
                              }
                              : {
                                padding: "6px 16px",
                                border: isSelected ? "2px solid #000" : "1px solid #ccc",
                                borderRadius: "6px",
                                backgroundColor: isSelected ? "#000" : "#fff",
                                color: isSelected ? "#fff" : "#000",
                                fontWeight: "500",
                                fontSize: "14px",
                                cursor: "pointer",
                                minWidth: "45px",
                              };

                          return (
                            <button key={i} onClick={handleClick} style={style}>
                              {attr.name === "colors" || attr.name === "Colors" ? "" : val}
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  );
                })}

              </div>
            </div>

          </div>
          {/* Product Reviews */}
          <div className="mt-5">
            <h4 className="mb-3">Product Reviews</h4>
            {review?.length > 0 ? (
              review.map((r, i) => (
                <div className="card mb-3 p-4 shadow-sm border-0" key={i}>
                  <div className="d-flex align-items-start gap-3">
                    <img
                      src={r.userImage}
                      alt=""
                      style={{ width: "60px", height: "60px", borderRadius: "50%" }}
                    />
                    <div className="flex-grow-1">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <strong className="text-dark">{r.firstName} {r.lastName}</strong>
                          <p className="text-muted mb-1 small">{r.time}</p>
                        </div>
                        <Rating initialValue={r.rating} readonly allowFraction size={20} />
                      </div>
                      <p className="mt-2 text-secondary small">{r.review}</p>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-muted">No reviews found.</div>
            )}


          </div>

        </div>
      </div>


    </div>
  );
};

export default connect(null, {
  getProductDetail,
  outOfStock,
  getProductReview,
})(ProductDetail);
